<div *ngIf="reviews" class="container">
    <finder-picture *ngIf="reviews.image" class="logo" [picture]="reviews.image"></finder-picture>
    <div class="content">
        <h3 *ngIf="reviews.title" class="title">{{reviews.title}}</h3>
        <finder-picture *ngIf="reviews.reviewImage" class="review-rating" [picture]="reviews.reviewImage"></finder-picture>
        <finder-anchor *ngIf="reviews.reviewUrl"
            class="review-count"
            id="review-count"
            [ariaLabel]="reviews.ariaLabel"
            [href]="reviews.reviewUrl"
            target="_blank">
                {{reviews.reviewCount}}
        </finder-anchor>
    </div>
</div>
